import styled, { css } from 'styled-components';
import device from 'utils/device'

export default styled.div`
  ${({ displayState, isHovered }) => css`
    background-color: white;
    width: 100vw;
    height: 100%;
    overflow: auto;
    position: relative;
    display: flex;
    flex-direction: column;

    border: ${isHovered ? `3px dashed ${window?.settings?.secondary_color ?? '#04333b'}99` : ''};

    ${isHovered && css`
      :after {
        content: "Drop files here";
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        position: absolute;
        font-weight: 600;
        font-size: 24px;
        border-radius: 20px;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        background: ${`${window?.settings?.secondary_color ?? '#04333b'}99`};
        pointer-events: none;
      }
    `}

    
    @media ${device.laptop} {
      box-shadow: 0px 4px 40px rgba(160, 174, 192, 0.15);
      max-height: calc(100vh - 70px);
      max-width: calc(100vw - 100px);
      border-radius: 20px;
      width: ${displayState?.width ?? '800px'};
      height: calc(100vh - 100px);
      overflow: unset;
    }

    @media screen and (min-width: 1280px) {
      border-radius: ${displayState?.visibleSidebar ? '20px 0px 0px 20px' : '20px'};
      transition: border-radius 500ms;
      transform:  ${displayState?.visibleSidebar ? ' translate(-200px)' : ''};
      transition: transform 500ms;
    }
  `}
`;